import React from 'react';
import ReactDOM from 'react-dom';
import {message} from "antd";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import storageUtils from "./utils/storageUtils";
import memoryUtils from "./utils/memoryUtils";
import "./config/config"
import Promise from 'babel-polyfill';
import 'core-js/es'
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import promise from 'es6-promise';
promise.polyfill();
let leavePage = 0;
// 解决promise 在ie中未定义的问题
if (!window.Promise) {
    window.Promise = Promise;
}
document.addEventListener("visibilitychange", function () {
    let type = sessionStorage.getItem("testing");
    if (!document.hidden&&type==="ing") {   //处于当前页面
        leavePage++;
        if(leavePage===1){
            message.error("你已离开页面一次，第二次将直接提交答卷！")
        }
        if(leavePage>=2){
            sessionStorage.setItem("leavePage","leavePage");
            leavePage = 0;
            document.getElementById("submit").click();
        }
    }
});
const normalWidth = window.innerWidth;
const normalHeight = window.innerHeight;
window.onresize = function(){
    let type = sessionStorage.getItem("testing");
    if(type==="ing"&&(normalWidth>window.innerWidth||normalHeight< window.innerHeight)){
        leavePage+=0.5;
        if(leavePage===1){
            message.error("你已离开页面一次，第二次将直接提交答卷！")
        }
        if(leavePage>=2){
            sessionStorage.setItem("leavePage","leavePage");
            leavePage = 0;
            document.getElementById("submit").click();
        }
    }
};
document.onkeydown=function (e){
    let type = sessionStorage.getItem("testing");
    if (!document.hidden&&type==="ing") {   //处于当前页面
        let currKey=0,evt=e||window.event;
        currKey=evt.keyCode||evt.which||evt.charCode;
        if (currKey === 123||e.ctrlKey) {
            window.event.cancelBubble = true;
            window.event.returnValue = false;
        }
    }
};
//禁止按键F5
document.onkeydown = function(e){
    e = window.event || e;
    let keycode = e.keyCode || e.which;
    if( keycode === 116){
        if(window.event){// ie
            try{e.keyCode = 0;}catch(e){}
            e.returnValue = false;
        }else{// ff
            e.preventDefault();
        }
    }
};
document.onmousedown=function(event){
    let type = sessionStorage.getItem("testing");
    if (!document.hidden&&type==="ing") {   //处于当前页面
        if(event.button===2){
            alert( '禁止右键');
        }
    }
};
/**
 * 入口js
 */
const user = storageUtils.getUser();
memoryUtils.user = user;

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
